import React from "react";
import type {CitationSource} from "@/types/ask";
import MarkdownSegment from "./MarkdownSegment";

const AskText: React.FC<{
  text: string;
  isMarkDown: boolean;
  sendAction?: (title: string, action: string | null) => Promise<void>;
  variant?: "default" | "v1";
  citations?: CitationSource[];
  preserveEmoji?: boolean;
}> = ({text, isMarkDown, sendAction, variant = "default", citations, preserveEmoji = false}) => {
  if (isMarkDown) {
    return (
      <MarkdownSegment
        text={text}
        isV1={variant === "v1"}
        sendAction={sendAction}
        citations={citations}
        preserveEmoji={preserveEmoji}
      />
    );
  }

  return <div className="whitespace-pre-wrap break-words">{text}</div>;
};

export default AskText;
